import Translation from './translation.vue';
import Vue from 'vue';

const defaults = {
    sourceLanguage: "",
    translationTitle:"",
    languagepack:[]
};
let TranslationInstance;
function getTranslationInstance (sourceLanguage=defaults.sourceLanguage,translationTitle=defaults.translationTitle,languagepack=defaults.languagepack,onOk,onCancel) {
        const _props =  {
            sourceLanguage: sourceLanguage,
            translationTitle: translationTitle,
            languagepack:languagepack,
            onOk:onOk
        };
        const Instance = new Vue({
            render (h) {
                return h(Translation, {
                    props: _props
                });
            }
        });
        const component = Instance.$mount();
        document.body.appendChild(component.$el);
        const notification = Instance.$children[0];
       // notification.$parent.onOk = _props.onOk;
        //notification.$parent.onCancel = _props.onCancel;
        return {
            destroy () {
                notification.close()
            }
        };
}


export default {
    name: 'Translation',
    process (options) {
        
        this.TranslationInstance=getTranslationInstance(options.sourceLanguage,options.translationTitle,options.languagepack,options.onOk,options.onCancel);

        return TranslationInstance;
    },
    close () {
        this.TranslationInstance.destroy()
    }
};;


// WEBPACK FOOTER //
// ./src/components/Translation/index.js